<template>
  <v-row class="bg-image" no-gutters>
    <v-card
      class="main-card mx-auto pa-5"
      :class="{
        'pa-5 mobile-main-card': $vuetify.breakpoint.smAndDown,
      }"
    >
        <v-card-title class="pa-0">
          <span
            class="font-weight-bold main-heading"
          >
            Sign Up Now
          </span>
        </v-card-title>
        <v-card-title class="pa-0">
          <span class="default-font text-wrapping caption">
            Signup here to login.
          </span>
        </v-card-title>
        <v-card-text class="pa-0 mt-6">
          <v-form
            class="mt-10"
            ref="form"
            lazy-validation
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="name"
              placeholder="Enter Your Full Name"
              outlined
              :rules="nameRules"
              class="login-field-button"
              color="#8692A6"
              name="name"
              :prepend-inner-icon="'mdi-account'"
              required
            ></v-text-field>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              placeholder="Enter Your Email"
              outlined
              :prepend-inner-icon="'mdi-email'"
              class="login-field-button"
              color="#8692A6"
              name="email"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              :prepend-inner-icon="'mdi-lock'"
              class="login-field-button"
              name="password"
              outlined
              outline
              placeholder="Enter Your Password"
              color="#8692A6"
              hint="At least 8 characters"
              counter
              required
              @click:append="show = !show"
              :rules="[
                rules.required,
                rules.passwordNumber,
                rules.passwordAlphabet,
                rules.passwordSpecial,
                rules.passwordLength,
              ]"
            ></v-text-field>
            <div class="text-center">
              <v-btn
                block
                class="adjust-btn-register px-7"
                @click="loader = false"
                :loading="loader"
                :disabled="loader"
                type="submit"
                large
              >
                Register
              </v-btn>
            </div>
            <v-row>
              <v-col cols="10" class="mt-5">
                <v-icon size="14" color="#8692A6">mdi-arrow-left</v-icon>
                <a class="caption appBlack--text" @click="login()">Login Now</a>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
    </v-card>
    <v-card-text >
      <v-row class="position-relative">
        <v-col offset-lg="2" offset-md="3" offset-sm="4">
          <p class="text-left mt-14 ml-5 pt-16 caption footer position-absolute">
            <a class="appGray--text">Privacy &nbsp; | &nbsp; Terms & Condition</a>
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-row>
</template>

<script>
import axios from "axios";
import { showSnackbar } from "../utils/GlobalActions";
export default {
  name: "SignIn",
  components: {},
  data() {
    return {
      show: false,
      snackbarSuccess: false,
      loader: false,
      successText: "",
      name: "",
      password: "",
      email: "",
      snackbarError: false,
      errorText: "",
      passwordRules: [
        (v) => !!v || "Required",
        (v) => v.length >= 8 || "Password must be 8 characters long",
      ],
      emailRules: [
        (v) => !!v || "Required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      nameRules: [(v) => !!v || "Required"],
      rules: {
        required: (value) => !!value || "This field is required",
        // emptyPassword: (value) =>
        //   /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{7,}$/.test(value) ||
        //   "Minimum 7 character required",
        passwordLength: (value) =>
          /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/.test(value) ||
          "Minimum 8 character required ",
        passwordNumber: (value) =>
          // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(value) ||
          /^(?=.*[0-9])/.test(value) || "Must contain at least 1 number",
        passwordAlphabet: (value) =>
          /^(?=.*[a-zA-Z])/.test(value) || "Must contain at least 1 alphabet",
        passwordSpecial: (value) =>
          /^(?=.*[!@#\$%\^&\*\)\(+=._-])/.test(value) ||
          "Must contain at least 1 special character",
      },
    };
  },

  methods: {
    loginRedirect() {
      this.$router.push({ name: "signin" });
    },
    login() {
      this.$router.push({ path: "/" });
    },
    onSubmit() {
      this.loader = true;
      if (this.$refs.form.validate()) {
        axios
          .post("/register", {
            name: this.name,
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            // this.$store.dispatch("updateUserId", response.data.user[0].id);
            // console.log(response.data,"signup")
            if (response.status == 201) {
              showSnackbar("Success!", "Account Created", "success");
              setTimeout(() => {
                this.$router.push({ name: "signin" });
              }, 2000);

              this.loader = false;
            }
          })
          .catch((error) => {
            this.loader = false;
            if (error.response.status == 422) {
              showSnackbar("Error!", error.response.data.message, "error");
            }
            showSnackbar("Error!", error.response.data.message, "error");
          });
      } else if (!this.$refs.form.validate()) {
        this.loader = false;
        showSnackbar("Error!", "All fields are required", "error");
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1024px) {
  .main-card {
    width: 370px;
    height: 460px;
    margin-top: 25%;  
    position: relative;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    right: 0%;
  }
  .bg-image {
    background: url('../assets/login-bg.svg') !important;
    height: 100%;
    background-size: cover !important;
  }
}
.bg-image {
  background: url('../assets/login-bg-web.svg');
  height: 100%;
  background-size: cover !important;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.adjust-form-heading {
  font-size: 28px;
  color: #434343;
}
.adjust-background-1 {
  min-height: 350px;
  background: #434343;
  clip-path: polygon(0 0, 100% 0%, 100% 99%, 0 84%);
}
.signin {
  min-height: 400px;
  width: 559px;
  box-sizing: border-box;
  box-shadow: none !important;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  z-index: 1;
  background: white;
  bottom: 200px;
}
.v-sheet.v-card {
  border-radius: 12px; 
}
.section-container {
  max-width: 100%;
}
.v-application .pa-5 {
  padding: 50px !important;
  padding-top: 25px !important;
}
.adjust-btn-register {
  /* width: 100% !important; */
  height: 38px !important;
  background: #161c27 !important;
  color: white !important;
  font-size: 24px;
  /* border-radius: 7px; */
}
.v-icon.v-icon.v-icon--link {
  margin-top: 15px;
}

</style>
<style >
.mdi-account {
  color: #644ded !important;
  margin-bottom: 10px;
}
.mdi-lock {
  color: #644ded !important;
  margin-bottom: 10px;
}
.mdi-email {
  color: #644ded !important;
  margin-bottom: 10px;
}
.mdi-eye-off {
  margin-bottom: 10px !important;
  color: #644ded !important;
}
.mdi-eye {
  margin-bottom: 10px !important;
  color: #644ded !important;
}
.v-application--is-ltr .v-text-field .v-input__append-inner {
  margin-top: 18px;
}
.login-field-button .v-icon {
  color: #8692a6 !important;
  margin-bottom: 10px;
}
/* new style  */
.main-card {
  width: 446px;
  height: 480px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  margin-top: 12%;  
  position: relative;
  right: 24%;
}
.main-heading {
  font-size: 24px !important;
  font-weight: 600 !important;
}
</style>